// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfm {
  white-space: normal !important;
  word-wrap: normal !important;
  line-height: 1.6;
  color: var(--text-color-mix);
}

.gfm h1,
.gfm h2,
.gfm h3,
.gfm h4,
.gfm h5,
.gfm h6 {
  font-weight: bold;
  margin-bottom: 0.5em;
}
.gfm h1 {
  font-size: 2em;
}
.gfm h2 {
  font-size: 1.5em;
}
.gfm h3 {
  font-size: 1.17em;
}
.gfm h4 {
  font-size: 1em;
}
.gfm h5 {
  font-size: 0.83em;
}
.gfm h6 {
  font-size: 0.67em;
}
.gfm p {
  display: block;
  margin-top: 0;
  margin-bottom: 1em;
  padding: 0;
}

.gfm img {
  zoom: normal;
  width: 100%;
  margin: 0px;
  padding: 0px;
  border-radius: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.gfm img:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.gfm p:has(> :nth-child(2)) > img {
  width: calc(100% / 2 - 3px);
}

.gfm p:has(> :nth-child(3)) > img {
  width: calc(100% / 3 - 3px);
}

.gfm p:has(> :nth-child(4)) > img {
  width: calc(100% / 4 - 4px);
}

.gfm a {
  color: #0366d6;
  text-decoration: none;
}
.gfm a:hover {
  color: #0366d6;
  text-decoration: underline;
}
.gfm ul,
.gfm ol {
  margin-top: 0;
  margin-bottom: 1em;
  padding-left: 2em;
}
.gfm li {
  margin-bottom: 0.5em;
}
.gfm code {
  background-color: #f6f8fa;
  border-radius: 3px;
  font-size: 0.9em;
  padding: 0.2em 0.4em;
}
.gfm pre {
  background-color: #f6f8fa;
  border-radius: 3px;
  font-size: 0.9em;
  line-height: 1.4;
  margin-bottom: 1em;
  padding: 1em;
  overflow-x: auto;
  white-space: pre-wrap;
}

.gfm table {
  width: 100%;
  border-collapse: collapse;
}

.gfm table,
.gfm th,
.gfm td {
  height: 16px;
  border: 1px solid black;
}
`, "",{"version":3,"sources":["webpack://./src/client/HoosatUI/src/Markdown/Markdown.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;;;EAME,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":["@import \"../theme.css\";\n\n.gfm {\n  white-space: normal !important;\n  word-wrap: normal !important;\n  line-height: 1.6;\n  color: var(--text-color-mix);\n}\n\n.gfm h1,\n.gfm h2,\n.gfm h3,\n.gfm h4,\n.gfm h5,\n.gfm h6 {\n  font-weight: bold;\n  margin-bottom: 0.5em;\n}\n.gfm h1 {\n  font-size: 2em;\n}\n.gfm h2 {\n  font-size: 1.5em;\n}\n.gfm h3 {\n  font-size: 1.17em;\n}\n.gfm h4 {\n  font-size: 1em;\n}\n.gfm h5 {\n  font-size: 0.83em;\n}\n.gfm h6 {\n  font-size: 0.67em;\n}\n.gfm p {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1em;\n  padding: 0;\n}\n\n.gfm img {\n  zoom: normal;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  border-radius: 20px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n.gfm img:hover {\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.gfm p:has(> :nth-child(2)) > img {\n  width: calc(100% / 2 - 3px);\n}\n\n.gfm p:has(> :nth-child(3)) > img {\n  width: calc(100% / 3 - 3px);\n}\n\n.gfm p:has(> :nth-child(4)) > img {\n  width: calc(100% / 4 - 4px);\n}\n\n.gfm a {\n  color: #0366d6;\n  text-decoration: none;\n}\n.gfm a:hover {\n  color: #0366d6;\n  text-decoration: underline;\n}\n.gfm ul,\n.gfm ol {\n  margin-top: 0;\n  margin-bottom: 1em;\n  padding-left: 2em;\n}\n.gfm li {\n  margin-bottom: 0.5em;\n}\n.gfm code {\n  background-color: #f6f8fa;\n  border-radius: 3px;\n  font-size: 0.9em;\n  padding: 0.2em 0.4em;\n}\n.gfm pre {\n  background-color: #f6f8fa;\n  border-radius: 3px;\n  font-size: 0.9em;\n  line-height: 1.4;\n  margin-bottom: 1em;\n  padding: 1em;\n  overflow-x: auto;\n  white-space: pre-wrap;\n}\n\n.gfm table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.gfm table,\n.gfm th,\n.gfm td {\n  height: 16px;\n  border: 1px solid black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
